export default "__VITE_ASSET__CL1N$$Od__"